module.exports = __webpack_public_path__ + "img/1.7e9d9fe5.png";